import { LanguageSupportUtil } from '../language_support_util';

/**
 * getTrailLocationUrl returns a localized url for a given trail.
 * @param {*} trail
 * @param {string} languageRegionCode
 * @returns string
 */
export const getTrailLocationUrl = (trail, languageRegionCode) => {
  let innerUrl;
  if (trail.park_slug) {
    innerUrl = `/parks/${trail.park_slug}`;
  } else if (trail.area_slug) {
    innerUrl = `/${trail.area_slug}`;
  } else if (trail.city_url) {
    innerUrl = `/${trail.city_url}`;
  } else {
    return null;
  }
  if (innerUrl.indexOf('?') < 0) {
    innerUrl = `${innerUrl}?ref=result-card`;
  }
  return LanguageSupportUtil.wrapUrlSafe(innerUrl, languageRegionCode);
};

/**
 * getLocationUrl returns a localized url for a given location and location type.
 * @param {string} locationString
 * @param {string} locationType
 * @param {string} languageRegionCode
 * @returns string
 */
export const getLocationUrl = (locationString, locationType, languageRegionCode) => {
  let locationPath = null;
  if (locationType === 'area') {
    locationPath = `/parks/${locationString}`;
  } else if (locationType === 'city') {
    locationPath = `/${locationString}`;
  }
  return LanguageSupportUtil.wrapUrlSafe(locationPath, languageRegionCode);
};

/**
 * getTrailLocationInfo returns a location and location type for a trail.
 * @param {*} trail
 * @returns [string, string]
 */
export const getTrailLocationInfo = trail => {
  let locationString = '';
  let locationType = '';
  if (trail.park_slug) {
    locationString = trail.park_slug;
    locationType = 'area';
  } else if (trail.area_slug) {
    locationString = trail.area_slug.replace(/^parks\//, '');
    locationType = 'area';
  } else if (trail.city_url) {
    locationString = trail.city_url;
    locationType = 'city';
  } else if (trail.area_id) {
    locationString = trail.area_id;
    locationType = 'area_id';
  } else if (trail.city_id) {
    locationString = trail.city_id;
    locationType = 'city_id';
  } else if (trail.state_id) {
    locationString = trail.state_id;
    locationType = 'state_id';
  }
  return [locationString, locationType];
};
